import { styled } from '@mui/material';

import { TABLET_MIN_WIDTH } from '~/constants/common';
import { COLORS } from '~/styles/colors';

// StyledContainer props type definition
type StyledContainerProps = {
  $fontSize?: string;
  $fontWeight?: number;
};

export const StyledContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== '$fontSize' && prop !== '$fontWeight',
})<StyledContainerProps>(({ theme, $fontSize, $fontWeight }) => ({
  display: 'inline-block',
  border: `2px solid ${COLORS.primary}`,
  borderRadius: '5px',
  color: COLORS.primary,
  fontSize: $fontSize,
  fontWeight: $fontWeight,
  position: 'relative',
  marginBlock: '2px',
  paddingInline: 5,
  [theme.breakpoints.down(TABLET_MIN_WIDTH)]: {
    fontSize: '22px',
    fontWeight: 600,
    width: 'fit-content',
  },
}));

export const StyledDot = styled('div')(() => ({
  position: 'absolute',
  width: '12px',
  height: '12px',
  backgroundColor: COLORS.primary,
  borderRadius: '50%',

  '&.top-left-dot': {
    top: '-8px',
    left: '-8px',
  },

  '&.top-right-dot': {
    top: '-8px',
    right: '-8px',
  },

  '&.bottom-left-dot': {
    bottom: '-8px',
    left: '-8px',
  },

  '&.bottom-right-dot': {
    bottom: '-8px',
    right: '-8px',
  },
}));
